const { coreApi } = require("./coreApi");

const feedbackApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getFeedback: builder.query({
      query: (query) => `/feedbacks?${query}`,
      providesTags: ["Feedbacks"],
    }),
  }),
});

export const { useGetFeedbackQuery, useLazyGetFeedbackQuery } = feedbackApi;
